import { NewsCard } from 'ui/components';

export const NewsCardFeature: React.FC<Umbraco.NewsCard> = ({ content, settings }) => <NewsCard {...content?.properties} settings={settings} />;
